const mapItems = (data = [], divider = ', ') => {
  return Object.values(data).join(', ');
};

export default mapItems;



// WEBPACK FOOTER //
// ./src/tools/mapnames.ts